import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IExpenseCategory } from "src/domain/entities"
import { ExpenseCategoryListView } from "."

interface Props {
	list: IExpenseCategory[]
	isLoading: boolean
	onUpdate: (expenseCategory: IExpenseCategory) => void
	onDelete: (expenseCategory: IExpenseCategory) => void
	onAddClick: () => void
}

export const ExpenseCategoryListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return (
			<BlankStateSection
				message="No Expense Categories found."
				onAddClick={onAddClick}
			/>
		)
	}

	return <ExpenseCategoryListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
